import WebsiteIdContext from '@providers/WebsiteIdContext'
import {useContext} from 'react'

export default function useWebsiteId() {
  const websiteId = useContext(WebsiteIdContext)

  return websiteId
}
